const tradeMarks= /[™®©]/g

export {tradeMarks}